export default "__VITE_ASSET__Bvqq_jSa__"